export const FormulaF = () => (
  <path
    d='M9.25 17.005C9.11193 17.005 9 16.8931 9 16.755V7.25C9 7.11193 9.11193 7 9.25 7H15.605C15.7431 7 15.855 7.11193 15.855 7.25V8.295C15.855 8.43307 15.7431 8.545 15.605 8.545H11.005C10.8669 8.545 10.755 8.65693 10.755 8.795V10.89C10.755 11.0281 10.8669 11.14 11.005 11.14H15.5C15.6381 11.14 15.75 11.2519 15.75 11.39V12.435C15.75 12.5731 15.6381 12.685 15.5 12.685H11.005C10.8669 12.685 10.755 12.7969 10.755 12.935V16.755C10.755 16.8931 10.6431 17.005 10.505 17.005H9.25Z'
    fill='currentColor'
  />
)
